import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStatisticsBar(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M17 18a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0v10ZM14 19a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v12a1 1 0 0 1-1 1ZM9 18a1 1 0 1 0 2 0v-7a1 1 0 1 0-2 0v7ZM5 18a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2Z"
      />
    </BaseIcon>
  );
}
